module.exports = __webpack_public_path__ + "img/connect_step1.1ec704d4.png";